import { Key } from 'antd/lib/table/interface';

export const EMPTY_COLUMN = {
  key: 'empty',
};

export const PAGINATION_DEFAULT = {
  defaultPageSize: 10,
  pageSizeOptions: ['10', '20', '50', '100', '200', '500', '1000', '10000'],
  showSizeChanger: true,
};

export const STICKY_DEFAULT = { offsetHeader: 56 };

export const SYSTEM_COLUMNS: Key[] = ['actions'];
